import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { AppUrlConstants } from "../constants/AppUrlConstants";
import { GenericCrudService } from "./generic-crud.service";
import { FormGroup } from "@angular/forms";
const headers = new HttpHeaders().set('X-Skip-Spinner', 'true');

@Injectable({
  providedIn: "root",
})
export class ApplicationDataService {
  constructor(
    private http: HttpClient,
    private crudService: GenericCrudService,
  ) {}

    private notificationsLoaded = false;
private notificationsSubject = new BehaviorSubject<any[]>([]);
  getAllSegments() {
    return this.crudService.getAll(
      AppUrlConstants.SEGMENT_URL + AppUrlConstants.LIST
    );
  }
  getAllUsers() {
    return this.crudService.getAll(
      AppUrlConstants.USER_URL + AppUrlConstants.LIST
    );
  }
  getAllActiveInactiveInternalUsers(){
    return this.crudService.getAll(AppUrlConstants.USER_URL+AppUrlConstants.ACTIVE_INACTIVE_USERS_INTERNAL_LIST);
  }
  getAllComplaintCategoriesBySegment(id: number) {
    return this.crudService.getById(
      id,
      AppUrlConstants.COMPLAINT_CATEGORY_URL + AppUrlConstants.SEGMENT
    );
  }
  getAllComplaintSubCategoriesSegment(id: number) {
    return this.crudService.getById(
      id,
      AppUrlConstants.COMPLAINT_SUB_CATEGORY_URL + AppUrlConstants.SEGMENT
    );
  }
  getAllComplaintByParentCategory(id: number) {
    return this.crudService.getById(
      id,
      AppUrlConstants.COMPLAINT_CATEGORY_URL + AppUrlConstants.PARENT_CATEGORY
    );
  }
  searchComplaint(object: any) {
    return this.crudService.search(
      object,
      AppUrlConstants.COMPLAINT_URL + AppUrlConstants.SEARCH
    );
  }
  updateComplaint(object: any) {
    return this.crudService.edit(
      object,
      AppUrlConstants.COMPLAINT_URL + AppUrlConstants.EDIT
    );
  }
  getDivision(object: any) {
    return this.crudService.getById(
      object,
      AppUrlConstants.COMPLAINT_URL + AppUrlConstants.SEARCH
    );
  }
  getByType(object: any) {
    return this.crudService.getByType(
      object,
      AppUrlConstants.ADMINISTRATIVE_STRUCTURE_URL + AppUrlConstants.GET_BY_TYPE
    );
  }
  getAdmStructurebyParentId(id: any) {
    return this.crudService.getById(
      id,
      AppUrlConstants.ADMINISTRATIVE_STRUCTURE_URL +
        AppUrlConstants.BY_PARETN_ID
    );
  }
  getAllWorkFlowStepsBySegment(id: number) {
    return this.crudService.getById(
      id,
      AppUrlConstants.COMPLAINT_PROCESS_URL + AppUrlConstants.SEGMENT
    );
  }
  getComplaintById(id: any) {
    return this.crudService.getById(id, AppUrlConstants.COMPLAINT_URL);
  }
  getSegmentById(id: number) {
    return this.crudService.getById(id, AppUrlConstants.SEGMENT_URL);
  }
  getGroupById(id: number) {
    return this.crudService.getById(id, AppUrlConstants.GROUP_URL);
  }
  getPermissionByGroup(id: number) {
    return this.crudService.getById(
      id,
      AppUrlConstants.PERMISSION_URL + AppUrlConstants.GROUP
    );
  }
  getPermissionByUser(id: number) {
    return this.crudService.getById(
      id,
      AppUrlConstants.PERMISSION_URL + AppUrlConstants.user
    );
  }
  getAllFrames() {
    return this.crudService.getAll(
      AppUrlConstants.FRAME_URL + AppUrlConstants.LIST
    );
  }

  getAdminStructureByIds(object: any) {
    return this.crudService.search(
      object,
      AppUrlConstants.ADMINISTRATIVE_STRUCTURE_URL +
        AppUrlConstants.ADMIN_STRUCTURE_BY_IDS
    );
  }
  getAdminStructureByParentIds(object: any) {
    return this.crudService.search(
      object,
      AppUrlConstants.ADMINISTRATIVE_STRUCTURE_URL +
        AppUrlConstants.ADMIN_STRUCTURE_BY_PARENT_IDS
    );
  }
  getTrckingByComplaintId(id: any) {
    return this.crudService.getById(
      id,
      AppUrlConstants.COMPLAINT_URL + AppUrlConstants.TRACKING
    );
  }
  addDocumentService(object: any) {
    return this.crudService.add(
      object,
      AppUrlConstants.COMPLAINT_URL + AppUrlConstants.DOCUMENT
    );
  }
  deleteDocumentService(id: any) {
    return this.crudService.delete(id, AppUrlConstants.DOCUMENT_DELETE_URL);
  }
  updateComplaintDocumentService(object: any) {
    return this.crudService.put(
      object,
      AppUrlConstants.COMPLAINT_URL + AppUrlConstants.DOCUMENT
    );
  }
  getTotalComplaintsByStatus() {
    return this.crudService.getAll(
      AppUrlConstants.DASHBOARD_URL + AppUrlConstants.COMPLAINT_BY_STATUS_COUNT
    );
  }
  getTotalComplaintsByCategoryCount(dateRange: any) {
    return this.crudService.add(
      dateRange,
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_CATEGORY_COUNT
    );
  }
  getComplaintsByStatusAndDivisionCount(object: any) {
    return this.crudService.add(
      object,
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_DIVISION_AND_STATUS_COUNT
    );
  }
  getComplaintsByDivisionCount(object: any) {
    return this.crudService.add(
      object,
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_DIVISION_COUNT
    );
  }
  getComplaintsByMonthCount() {
    return this.crudService.getAll(
      AppUrlConstants.DASHBOARD_URL + AppUrlConstants.COMPLAINT_BY_MONTH_COUNT
    );
  }
  getAllInternalUsers() {
    return this.crudService.getAll(
      AppUrlConstants.USER_URL + AppUrlConstants.USERS_INTERNAL
    );
  }
  sendEmailService(object: any) {
    return this.crudService.add(
      object,
      AppUrlConstants.NOTIFICATION_URL + AppUrlConstants.SEND_EMAIL
    );
  }
  sendSmsService(object: any) {
    return this.crudService.add(
      object,
      AppUrlConstants.NOTIFICATION_URL + AppUrlConstants.SEND_SMS
    );
  }

  getTotalComplaintsBySubCategoryCount(category: string) {
    return this.crudService.add(
      { name: category },
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_SUBCATEGORY_COUNT
    );
  }

  getTotalComplaintsByDistictCount(object: any) {
    return this.crudService.add(
      object,
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_DISTRICT_COUNT
    );
  }

  getTotalComplaintsByTehsilCount(object: any) {
    return this.crudService.add(
      object,
      AppUrlConstants.DASHBOARD_URL + AppUrlConstants.COMPLAINT_BY_TEHSIL_COUNT
    );
  }

  getTotalComplaintsByMouzaCount(object: any) {
    return this.crudService.add(
      object,
      AppUrlConstants.DASHBOARD_URL + AppUrlConstants.COMPLAINT_BY_mouza_COUNT
    );
  }
  getTotalComplaintsByAgentAllCount() {
    return this.crudService.getAll(
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_AGENT_ALL_COUNT
    );
  }

  getTotalComplaintsByAgentCount(filters: any) {
    return this.crudService.add(
      filters ?? {},
      AppUrlConstants.DASHBOARD_URL + AppUrlConstants.COMPLAINT_BY_AGENT_COUNT
    );
  }

  getTotalComplaintsByAgentAllDetailCount() {
    return this.crudService.getAll(
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_AGENT_ALL_DETAIL_COUNT
    );
  }

  getTotalComplaintsByAgentDetailCount(data: any) {
    return this.crudService.add(
      data,
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_AGENT_DETAIL_COUNT
    );
  }

   getTotalComplaintsByStatusAndGender(object: any) {
    return this.crudService.add(
      object,
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_TOTAL_STATUS_AND_GENDER_COUNT 
    );
  }
  
  getComplaintsByStatusAndGender(object: any) {
  return this.crudService.add(
    object,
    AppUrlConstants.DASHBOARD_URL +
      AppUrlConstants.COMPLAINT_BY_STATUS_AND_GENDER_COUNT
  );
}

  getTotalComplaintsByUserStatusCount(dateRange: any) {
    return this.crudService.add(
      dateRange,
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_USER_STATUS_COUNT
    );
  }

  getTotalComplaintsByComplaintSummaryCount(object: any) {
    return this.crudService.add(
      object,
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_COMPLAINT_SUMMARY_COUNT
    );
  }
  getTotalComplaintsByCategoryAndSubcategoryCount(object: any) {
    return this.crudService.add(
      object,
      AppUrlConstants.DASHBOARD_URL +
        AppUrlConstants.COMPLAINT_BY_CATEGORY_AND_SUBCAREGORY_COUNT
    );
  }

  getDelayAgingList(payload: any) {
    return this.crudService.add(
      payload,
      AppUrlConstants.DASHBOARD_URL + AppUrlConstants.COMPLAINT_DELAY_AGING_LIST
    );
  }

  getDelayCategoryWise(payload: any) {
    return this.crudService.add(
      payload,
      AppUrlConstants.DASHBOARD_URL + AppUrlConstants.COMPLAINT_DELAY_CATEGORY_WISE
    );
  }

  getDelayUserWise(payload: any) {
    return this.crudService.add(
      payload,
      AppUrlConstants.DASHBOARD_URL + AppUrlConstants.COMPLAINT_DELAY_USER_WISE
    );
  }
  getAllInternalUsersByRegion(object: any) {
    return this.crudService.search(
      object,
      AppUrlConstants.USER_URL + AppUrlConstants.USERS_BYREGION
    );
  }
  getAllGroupsByRegion(object: any) {
    return this.crudService.search(
      object,
      AppUrlConstants.GROUP_URL + AppUrlConstants.GROUP_BYREGION
    );
  }
  dropComplaint(drop: any) {
    return this.crudService.edit(drop, AppUrlConstants.DROP_URL);
  }

  appealComplaint(appeal: any) {
    return this.crudService.edit(appeal, AppUrlConstants.APPEAL_URL);
  }

  changePassword(data: any) {
    return this.crudService.add(data, AppUrlConstants.CHANGE_PASSOWRD_URL);
  }

  getUserByUserName() {
    return this.crudService.getAll(AppUrlConstants.USER_FIND_BY_USER_NAME);
  }

  forgetPassword(userName: string) {
    return this.crudService.add(
      { userName },
      AppUrlConstants.FORGET_PASSWORD_URL
    );
  }

  saveNewPassword(data: {
    userName: string;
    password: string;
    otp: string;
  }): Observable<any> {
    const url = `${AppUrlConstants.host}${AppUrlConstants.AUTH_URL}/saveNewPassword`;
    return this.http.post<any>(url, data);
  }

  publishDocument(data: any) {
    return this.crudService.add(data, AppUrlConstants.PUBLISH_DOCUMENT_URL);
  }
  getAllComplaintSubCategories() {
    return this.crudService.getAll(AppUrlConstants.COMPLAINT_SUB_CATEGORY_URL);
  }
  markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control?.invalid) {
        control?.markAsTouched();
      }
    });
  }

getUserNotifications(): Observable<any> {
const headers = new HttpHeaders().set('X-Skip-Spinner', 'true');

  return this.crudService.getAll(AppUrlConstants.GET_NOTIFICATION_URL, { headers });
}


markReadNotification(id: any) {
  return this.crudService.getById(id, AppUrlConstants.MARK_NOTIFICATION_URL);
}

getSmsTrackingCount(dateRange?: { dateFrom?: string; dateTo?: string }) {
  return this.crudService.add(
    dateRange ?? {},
    AppUrlConstants.SMS_TRACKING_URL + AppUrlConstants.SMS_TRACKING_COUNT
  );
}

getSmsTrackingDetails(payload: {
  dateFrom?: string;
  dateTo?: string;
  statusFilter: string;
  smsType?: string;
  pageNo: number;
  pageSize: number;
}) {
  return this.crudService.add(
    payload,
    AppUrlConstants.SMS_TRACKING_URL + AppUrlConstants.SMS_TRACKING_DETAILS
  );
}
 getPersonalInfo(id: any) {
    return this.crudService.getAll(AppUrlConstants.GET_PERSONAL_INFO_URL+ "/" + id);
 }

  getWhatsAppSessions(body: { mobileNumber?: string; dateFrom?: string; dateTo?: string }, page: number, size: number) {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    const headers = new HttpHeaders().set('Accept', 'application/json').set('X-Skip-Spinner', 'true');
    return this.http.post<any>(AppUrlConstants.WHATSAPP_SUMMARY, body, { params, headers });
  }

  getWhatsAppConversation(phone: string) {
    const headers = new HttpHeaders().set('Accept', 'application/json').set('X-Skip-Spinner', 'true');
    return this.http.get<any>(`${AppUrlConstants.WHATSAPP_CONVERSATION}/${phone}`, { headers });
  }

  getWhatsAppAiAgentSessions(body: { mobileNumber?: string; dateFrom?: string; dateTo?: string }, page: number, size: number) {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    const headers = new HttpHeaders().set('Accept', 'application/json').set('X-Skip-Spinner', 'true');
    return this.http.post<any>(AppUrlConstants.WHATSAPP_AI_AGENT_SUMMARY, body, { params, headers });
  }

  getWhatsAppAiAgentConversation(phone: string) {
    const headers = new HttpHeaders().set('Accept', 'application/json').set('X-Skip-Spinner', 'true');
    return this.http.get<any>(`${AppUrlConstants.WHATSAPP_AI_AGENT_CONVERSATION}/${phone}`, { headers });
  }

  getWhatsAppAiAgentAudio(id: number, side: 'inbound' | 'reply') {
    const headers = new HttpHeaders().set('X-Skip-Spinner', 'true');
    return this.http.get(`${AppUrlConstants.WHATSAPP_AI_AGENT_AUDIO}/${id}/${side}`, {
      headers,
      responseType: 'blob'
    });
  }

  getChatbotAssistLogs(dateFrom?: string, dateTo?: string) {
    let params = new HttpParams();
    if (dateFrom) params = params.set('date_from', dateFrom);
    if (dateTo) params = params.set('date_to', dateTo);
    const headers = new HttpHeaders().set('Accept', 'application/json').set('X-Skip-Spinner', 'true');
    return this.http.get<any>(AppUrlConstants.CHATBOT_ASSIST_LIST, { params, headers });
  }

  getComplaintStatus(complaintNum: string) {
    const url = AppUrlConstants.host + AppUrlConstants.COMPLAINT_STATUS_CHECK_URL;
    const skipHeaders = new HttpHeaders({ 'X-Skip-Spinner': 'true', 'X-Skip-Auth': 'true' });
    return this.http.post<any>(url, { complaintNum }, { headers: skipHeaders });
  }

  verifyOTP(complaintNum: string, OTP: string) {
    const url = AppUrlConstants.host + AppUrlConstants.COMPLAINT_OTP_VERIFY_URL;
    const skipHeaders = new HttpHeaders({ 'X-Skip-Spinner': 'true', 'X-Skip-Auth': 'true' });
    return this.http.post<any>(url, { complaintNum, OTP }, { headers: skipHeaders });
  }

}
